//* 组件库
import { utility } from "various-ui";
import type { ModuleData, ModuleTableOption } from "../index";
export const useComposable = () => {
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        //* 页面控制变量
        loading: ref<boolean>(true),
        exist: ref<boolean>(true),
        //* 表头选项
        option: ref<ModuleTableOption[]>([]),
        //* 表格数据
        list_data: ref<ModuleData[]>([]),
        //*  表型类
        types: ref<string[]>([]),
        //* 多选框选项
        columns: ref<string[]>([]),
    };

    //*  静态变量
    const variable = {
        labels: [
            {
                name: "hm",
                color: "#CAA3E8",
                label: i18n.t("Homozygotes"),
            },
            {
                name: "ht",
                color: "#98C8EA",
                label: i18n.t("Heterozygous"),
            },
            {
                name: "cn",
                color: "#9CE7E9",
                label: i18n.t("ConditionalGenotype"),
            },
            {
                name: "cx",
                color: "#F0B0B0",
                label: i18n.t("Complex1GenomeFeature"),
            },
            {
                name: "tg",
                color: "#E1B0DE",
                label: i18n.t("InvolvesTransgenes"),
            },
            {
                name: "ot",
                color: "#FFD690",
                label: i18n.t("OtherHemizygousIndeterminate"),
            },
        ],

        //* 表格列表初始数据
        listData: [],
    };

    //* 函数列表
    const methods = {
        //* 渲染函数
        render: (renderData: any) => {
            if (!renderData.data.length) return methods.hidden();
            else {
                //* 数据更新 (存储在静态变量，后期处理)
                variable.listData = renderData.data;
                refs.option.value = renderData.title;

                //* 获取选择框选项
                const columns = refs.option.value.map((value) => {
                    return value.name.substring(0, 2);
                });
                refs.columns.value = Array.from(new Set(columns));

                //* 初始化默认全选所有类型
                refs.types.value = utility.cloneDeep(refs.columns.value);

                //* 递归过滤表格数据
                refs.list_data.value = utility.cloneDeep(renderData.data);

                refs.loading.value = false;
            }
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 栏目切换
        switchColumn: (name: string) => {
            //* 栏目增删数据
            const index = refs.types.value.findIndex((value) => value == name);
            if (index != -1) {
                refs.types.value.splice(index, 1);
            } else {
                refs.types.value.push(name);
            }
            //* 重新赋值并过滤
            refs.list_data.value = utility.cloneDeep(variable.listData);
            methods.filterListData(refs.list_data.value);
        },

        //* 展开表格行开关 （递归组件emit触发）
        switchLine: (data: ModuleData) => {
            data.active = !data.active;
        },

        //* 递归过滤表格数据
        filterListData: (params: ModuleData[]) => {
            params.forEach((value) => {
                value.values = value.values.filter((v1) => {
                    return refs.types.value.includes(v1.name.substring(0, 2));
                });

                if (value.children != null && value.children?.length > 0) {
                    methods.filterListData(value.children);
                }
            });
        },
    };

    const computeds = {
        //*  根据选择的表型type获取表格头
        headerComputed: computed(() => {
            const arr = refs.option.value.filter((value) => {
                return refs.types.value.includes(value.name.substring(0, 2));
            });

            arr.forEach((item) => {
                item.color = variable.labels.find((v1) => {
                    return item.name.includes(v1.name);
                })?.color;
            });
            return arr;
        }),
    };

    //* 属性列表
    const binds = reactive({
        columns: {
            align: "start" as "start",
            trigger: "hover" as "hover",
            direction: "bottom" as "bottom",
            offset: 4,
        },
    });

    return { refs, methods, computeds, variable, binds };
};
